import { Component, Input, OnInit, HostListener, ElementRef } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { sendDripsPhone } from '../_actions/drips.actions';
import brandInfo from "src/environments/brand.json";
import { AppConfigService } from '../appconfig/appconfig.service';


@Component({
  selector: 'app-modal-drips',
  standalone: false,
  templateUrl: './modal-drips.component.html',
  styleUrls: ['./modal-drips.component.scss']
})
export class ModalDripsComponent implements OnInit {

  @Input() title: string;
  @Input() content: string;
  form: FormGroup;
  showSuccessMessage: boolean = false;
  brandInfo: any;
  branding: any;
  isMobile: boolean = false;
  
  constructor(
    public modalRef: MDBModalRef,
    private fb: FormBuilder,
    private store: Store<{
      drips: any
    }>,
    private appConfig: AppConfigService,
    private elementRef: ElementRef
  ) {
    this.form = this.fb.group({
      phone: ['', [Validators.required, Validators.pattern(/\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{4}/)]]
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  ngOnInit(): void {
    this.brandInfo = brandInfo;
    this.checkScreenSize();
    this.appConfig.getSettings().subscribe((result) => {
      this.branding = result;
      this.setBackgroundImage();
    });
  }

  private checkScreenSize(): void {
    this.isMobile = window.innerWidth <= 787;
    this.setBackgroundImage();
  }

  private setBackgroundImage(): void {
    if (!this.branding) return;

    const modalElement = this.elementRef.nativeElement.querySelector('.modal-content');
    if (!modalElement) return;

    let backgroundImage = '';
    
    if (this.isMobile && this.branding.drips_modal_mobile_image) {
      backgroundImage = this.branding.drips_modal_mobile_image.url;
    } else if (!this.isMobile && this.branding.drips_modal_desktop_image) {
      backgroundImage = this.branding.drips_modal_desktop_image.url;
    }

    if (backgroundImage) {
      modalElement.style.backgroundImage = `url('${backgroundImage}')`;
    }
  }

  sendMessage() {
    if (this.form.valid) {
      console.log(this.form.value);
      this.showSuccessMessage = true;
      window.sessionStorage.setItem('dripsModalShown', 'true');
      let _vehicle = JSON.parse(sessionStorage.getItem('vehicle'));
      let _opportunityId = JSON.parse(sessionStorage.getItem("opp"));
      this.store.dispatch(sendDripsPhone({
        opportunityId: _opportunityId ? _opportunityId.opportunityId : null,
        phone: this.form.value.phone,
        make: _vehicle.make,
        model: _vehicle.model,
        state: _vehicle.registeredState, 
        year: _vehicle.year}));
    } else {
      this.form.controls.phone.markAsTouched();
    }

    console.log('sendMessage');
  }

  closeModal() {
    this.modalRef.hide();
  }

}
